import { $FixMe } from '@eventbrite/ts-utils';
import debounce from 'lodash/debounce';
import { useCallback, useEffect, useRef } from 'react';

export const useScrollWatcher = (
    callback: (value: number) => void,
    {
        deps = [],
        interval = 100,
    }: { deps: Array<boolean | number>; interval: number; selector?: string },
) => {
    const scrollListenerRef = useRef<$FixMe>(null);
    const position = useRef(0);

    const checkScrollPosition = useCallback(() => {
        callback(position.current);
        position.current = window.pageYOffset;
    }, [callback]);

    useEffect(() => {
        const handleScroll = () => {
            checkScrollPosition();
        };

        const debouncedHandleScroll = debounce(handleScroll, interval);

        scrollListenerRef.current = window.addEventListener(
            'scroll',
            debouncedHandleScroll,
        );

        return window.removeEventListener('scroll', scrollListenerRef.current);
        //eslint-disable-next-line
    }, [...deps, checkScrollPosition, interval]);
};
